import { render, staticRenderFns } from "./cprofileModal.vue?vue&type=template&id=28a49956&scoped=true&"
import script from "./cprofileModal.vue?vue&type=script&lang=js&"
export * from "./cprofileModal.vue?vue&type=script&lang=js&"
import style0 from "./cprofileModal.vue?vue&type=style&index=0&id=28a49956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a49956",
  null
  
)

export default component.exports